const dateChanged = (state = false, action) => {
    switch(action.type) {
        case 'dateChanged':
            return action.payload;
        default:
            return state;
    }
}

export default dateChanged;